// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const operatorId = (z.number());
export const operator = z.object({
    id: operatorId,
    first_name: z.string().nullable(),
    last_name: z.string().nullable(),
    image_url: z.string().nullable(),
    active: z.boolean().nullable(),
    email: z.string().nullable(),
    full_name: z.string().nullable(),
    google_id: z.string().nullable(),
    user_roles: z.string().array().nullable(),
    phone_e164: z.string().nullable(),
    created_at: z.date(),
    home_sections: z.string().array().nullable(),
});
export const operatorInitializer = z.object({
    id: operatorId.optional(),
    first_name: z.string().optional().nullable(),
    last_name: z.string().optional().nullable(),
    image_url: z.string().optional().nullable(),
    active: z.boolean().optional().nullable(),
    email: z.string().optional().nullable(),
    full_name: z.string().optional().nullable(),
    google_id: z.string().optional().nullable(),
    user_roles: z.string().array().optional().nullable(),
    phone_e164: z.string().optional().nullable(),
    created_at: z.date().optional(),
    home_sections: z.string().array().optional().nullable(),
});
export const operatorMutator = z.object({
    id: operatorId.optional(),
    first_name: z.string().optional().nullable(),
    last_name: z.string().optional().nullable(),
    image_url: z.string().optional().nullable(),
    active: z.boolean().optional().nullable(),
    email: z.string().optional().nullable(),
    full_name: z.string().optional().nullable(),
    google_id: z.string().optional().nullable(),
    user_roles: z.string().array().optional().nullable(),
    phone_e164: z.string().optional().nullable(),
    created_at: z.date().optional(),
    home_sections: z.string().array().optional().nullable(),
});
//# sourceMappingURL=Operator.js.map